import { AutoMap } from "@automapper/classes";
import { PrelevementGenerateurDialyseDTO } from "./prelevement-generateur.dto";

export class GenerateurDTO {
    @AutoMap()
    code: string = ''
    @AutoMap()
    zoneSalle: string = ''
    @AutoMap()
    samplingDate: string = ''
    @AutoMap()
    marque: string = ''
    @AutoMap()
    modele: string = ''
    @AutoMap()
    numSerie: string = ''
    @AutoMap()
    numAppareil: string = ''
    @AutoMap(() => [PrelevementGenerateurDialyseDTO])
    prelevementGenerateurDialyseList: PrelevementGenerateurDialyseDTO[] = [];
}